// extracted by mini-css-extract-plugin
export default {"parentStyle":"ib0cwzpARDrNy7QpWR2g","wrongValue":"In2kCVIDdFtnJT4ge5Yj"};